import React, { useState } from "react";

import { useNavigate } from "react-router-dom";
import { Button } from "./ui/button";
import spcaImage from "../assets/images/donations/1.png";
import tearsImage from "../assets/images/donations/2.png";
import greenImage from "../assets/images/donations/3.png";
import foodImage from "../assets/images/donations/4.png";
import saveImage from "../assets/images/donations/5.png";
import hopeImage from "../assets/images/donations/6.png";
import animalImage from "../assets/images/donations/7.png";
import treeImage from "../assets/images/donations/8.png";
import waterImage from "../assets/images/donations/9.png";
import aidImage from "../assets/images/donations/10.png";
import { Skeleton } from "./ui/skeleton";
import { useOrganisations } from "../hooks/query/queries";
const organisations = [
  {
    id: 1,
    name: "Johannesburg SPCA",
    description: "Protecting and caring for abused and abandoned animals.",
    category: "Animals",
    image: spcaImage,
    isNew: true,
    about:
      "The Johannesburg Society for the Prevention of Cruelty to Animals (JSPCA) was established in 1902 and is one of the largest animal welfare organisations in the country.ue",
    more: "The Society for the Prevention of Cruelty to Animals (SPCA) is a global network of organizations dedicated to protecting animals from abuse, neglect, and exploitation. With a mission to promote kindness and humane treatment, SPCA branches provide shelter, medical care, and adoption services for abandoned and mistreated animals. They also advocate for stronger animal welfare laws, educate communities about responsible pet ownership, and conduct rescues and investigations. Whether it's saving animals in crisis or finding them loving homes, the SPCA plays a vital role in ensuring the well-being of our furry and feathered friends.",
  },
  {
    id: 2,
    name: "Tears",
    description: "Bringing hope and healing to trauma and abuse victims.",
    category: "People",
    image: tearsImage,
    about:
      "Tears Animal Rescue is a leading pro-life, non-profit organization based in Cape Town, committed to alleviating the suffering of animals in under-resourced communities.",
    more: "Tears provides veterinary care, rescue services, rehabilitation, and rehoming for thousands of abused, neglected, and homeless pets every year. Beyond the shelter, their outreach programs offer mobile clinics, spay/neuter services, and community education. Their heartfelt mission is to create a more compassionate society where every animal has a chance to live a safe and healthy life.",
  },
  {
    id: 3,
    name: "Greenpop",
    description: "Bringing hope and healing to trauma and abuse victims.",
    category: "Environment",
    image: greenImage,
    about:
      "Greenpop is an environmental non-profit dedicated to restoring ecosystems and empowering communities through reforestation and urban greening projects",
    more: "Founded in 2010, Greenpop has planted over 150,000 trees across Southern Africa. Their programs include forest restoration, environmental education, and sustainable living workshops. By reconnecting people with nature, Greenpop inspires active citizenship and long-term ecological stewardship in schools, townships, and rural communities.",
  },
  {
    id: 4,
    name: "Food for All",
    description: "Providing food to those in need and reducing food wastage.",
    category: "People",
    image: foodImage,
    about:
      "Food for All is a grassroots initiative working to combat hunger and food insecurity by redistributing surplus food and providing nutritious meals to those in need.",
    more: "Operating across major South African cities, Food for All partners with retailers, farms, and donors to rescue edible food that would otherwise go to waste. Their mission is to ensure every person has access to healthy meals, while simultaneously reducing food waste and promoting food justice. Volunteers play a vital role in meal prep, distribution, and raising awareness.",
  },
  {
    id: 5,
    name: "Save the Planet",
    description: "Protecting the planet through sustainable initiatives.",
    category: "Environment",
    image: saveImage,
    about:
      "Save the Planet is a climate action organization focused on sustainable development, clean energy advocacy, and environmental education.",
    more: "With a vision of a greener tomorrow, Save the Planet empowers communities to take climate action through tree planting, renewable energy initiatives, clean-up campaigns, and policy advocacy. Their work targets both environmental preservation and social upliftment by creating green jobs and promoting eco-conscious habits in everyday life.",
  },
  {
    id: 6,
    name: "Hope Foundation",
    description: "Providing support and hope for underprivileged communities.",
    category: "Other",
    image: hopeImage,
    about:
      "The Hope Foundation is a non-profit dedicated to uplifting vulnerable communities through education, healthcare access, and youth empowerment.",
    more: "From building schools and health clinics to offering mentorship and skills training, the Hope Foundation tackles poverty at its roots. Their holistic approach to development helps children, women, and families break the cycle of hardship and achieve lasting change. Hope is more than a name—it's a promise of possibility and progress.",
  },
  {
    id: 7,
    name: "Animal Haven",
    description: "Caring for abandoned and injured animals.",
    category: "Animals",
    image: animalImage,
    about:
      "Animal Haven is a sanctuary and rescue centre offering refuge, rehabilitation, and adoption services for neglected and abandoned animals.",
    more: "Animal Haven operates with a no-kill policy and a deep commitment to animal welfare. They rescue pets from unsafe conditions, provide veterinary treatment, and match them with loving forever homes. Their community outreach includes school visits, cruelty prevention campaigns, and support for pet owners in low-income areas. Every life matters—and at Animal Haven, each one is cherished.",
  },
  {
    id: 8,
    name: "Tree Revival",
    description: "Promoting tree planting and forest conservation.",
    category: "Environment",
    image: treeImage,
    about:
      "Tree Revival is a conservation initiative focused on reforestation and protecting indigenous tree species in degraded ecosystems across South Africa",
    more: "Through volunteer-driven planting events, restoration workshops, and ecosystem monitoring, Tree Revival revitalizes natural habitats and fosters biodiversity. Their work combats climate change, restores wildlife corridors, and educates the public about the importance of trees in ecological health. With each tree planted, hope for the planet grows stronger.",
  },
  {
    id: 9,
    name: "Water for All",
    description: "Providing access to clean water for communities in need.",
    category: "People",
    image: waterImage,
    about:
      "Water for All is a humanitarian organization focused on providing clean, safe, and sustainable water solutions to underserved communities.",
    more: "Access to clean water changes everything—from health to education to gender equality. Water for All drills boreholes, installs filtration systems, and trains communities in water management to ensure long-term impact. Their work not only quenches thirst but also fosters dignity and opportunity in areas where water scarcity is a daily challenge.",
  },
  {
    id: 10,
    name: "AidReach",
    description: "Delivering essential aid to disaster-stricken areas.",
    category: "Other",
    image: aidImage,
    about:
      "AidReach is a disaster relief and community support organization dedicated to delivering emergency aid and long-term recovery solutions.",
    more: "From responding to floods and fires to supporting communities through food parcels, medical supplies, and trauma counselling, AidReach is often first on the ground and last to leave. Their mission goes beyond crisis response—they aim to rebuild lives with compassion, resilience, and dignity. In times of need, AidReach is a lifeline.",
  },
];

export default function DonationsList() {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All");

  const {
    data: orgs,
    isLoading: loadingOrgs,
    isError: orgError,
  } = useOrganisations();

  const filteredOrganisations = orgs?.filter((org) => {
    const matchesSearch = org?.organisation_info?.org_name
      ?.toLowerCase()
      .includes(search.toLowerCase());
    const matchesCategory =
      selectedCategory === "All" ||
      org?.organisation_info?.org_category?.toLowerCase() ===
        selectedCategory?.toLowerCase();
    return matchesSearch && matchesCategory;
  });
  const categories = ["All", "People", "Animals", "Environment", "Other"];

  return (
    <div className="flex justify-center mt-8 px-4 md:px-16 lg:px-32">
      <div className="max-w-5xl w-full">
        <div className="bg-white rounded-2xl shadow-sm p-6">
          <h2 className="text-xl font-semibold text-gray-800">Donations</h2>
          <p className="text-sm text-gray-600 mt-2">
            Support causes you care about directly through our platform...
          </p>

          <div className="flex items-center justify-start mt-6 space-x-4">
            <p className="text-sm font-semibold text-gray-800">Organisations</p>

            {categories?.map((categories) => (
              <button
                key={categories}
                className={`
                    px-4 py-1 rounded-full text-sm font-medium transition-colors
                    ${
                      selectedCategory === categories
                        ? "bg-rose-500 text-white"
                        : "bg-gray-200 text-gray-600 hover:bg-gray-300"
                    }
                  `}
                onClick={() => setSelectedCategory(categories)}
              >
                {categories}
              </button>
            ))}
          </div>

          <div className="relative mt-5">
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search organisations..."
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-8">
            {loadingOrgs
              ? Array.from({ length: 3 }).map((_, index) => (
                  <div
                    key={index}
                    className="max-w-l rounded-2xl overflow-hidden shadow-lg bg-white flex flex-col"
                  >
                    <div className="h-48 w-full">
                      <Skeleton className="w-full h-full bg-gray-300" />
                    </div>

                    <div className="flex flex-col justify-between flex-1 p-4 py-4">
                      <div className="mb-4 space-y-2">
                        <Skeleton className="h-4 w-3/4 bg-gray-300" />
                        <Skeleton className="h-3 w-1/2 bg-gray-300" />
                      </div>

                      <Skeleton className="h-10 w-full rounded-full bg-gray-300" />
                    </div>
                  </div>
                ))
              : filteredOrganisations?.map((org) => (
                  <div
                    key={org.id}
                    className="
                    relative
                    w-full h-full
                    bg-white
                    border border-gray-200
                    rounded-lg
                    shadow-sm
                    p-4
                    flex flex-col
                    items-center
                    transition-all
                    duration-200
                    ease-in-out
                    hover:-translate-y-1
                    hover:shadow-md
                    hover:bg-gray-50
                  "
                  >
                    {/* {org.isNew && (
                  <span className="absolute right-2 top-2 bg-pink-100 text-pink-600 text-xs font-semibold px-2 py-[2px] rounded-full">
                    NEW
                  </span>
                )} */}
                    <div className="h-48 w-full overflow-hidden">
                      <img
                        src={org?.organisation_info?.org_image_url}
                        alt={org?.organisation_info?.org_name}
                        width={70}
                        height={70}
                        className="w-full h-full object-cover object-center"
                      />
                    </div>
                    <div className="flex items-start justify-start w-full py-4">
                      <h3 className="text-lg font-medium text-gray-800">
                        {org?.organisation_info?.org_name}
                      </h3>
                    </div>
                    <div className="flex items-start justify-start w-full">
                      <p className="text-sm text-gray-600 mt-2 mb-4">
                        {org?.organisation_info?.org_short_description}
                      </p>
                    </div>

                    <Button
                      onClick={() => {
                        navigate("/settings/donations-view", {
                          state: {
                            donation: org,
                          },
                        });
                      }}
                      className="
                        w-full
                        bg-gradient-to-r
                        from-pink-500
                        to-purple-500
                        text-white
                        px-6
                        py-2
                        rounded-full
                        mt-4
                        text-sm
                        font-medium
                        hover:opacity-90
                        transition-opacity
                      "
                    >
                      View details
                    </Button>
                  </div>
                ))}
          </div>
        </div>
      </div>
    </div>
  );
}
